import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { reset } from '../../../utils/styled-reset';

const NoGeodata = () => {
  const { t } = useTranslation('cloudProcessing');
  return (
    <Component>
      <img src="/static/assets/img/cloudprocessing/state_empty.svg" />
      <p>
        <label>{t('geodataPage.list.noGeodata.title', { ns: 'cloudProcessing' })}</label>
        <span>
          {t('geodataPage.list.noGeodata.description', { ns: 'cloudProcessing' })}{' '}
          <b>{t('geodataPage.actions.newCloudProcess', { ns: 'cloudProcessing' })}</b>.
        </span>
      </p>
    </Component>
  );
};

const Component = styled.div`
  ${reset}
  font-size: 14px;

  display: flex;
  gap: 1em;
  flex-direction: row;
  margin: auto;

  p {
    width: 25em;
    margin: 2em 0 2em 0;
    display: block;

    label {
      font-weight: 500;
      display: block;
      margin-bottom: 0.5em;
    }

    span {
      font-weight: 300;
      b {
        padding-left: 0.3em;
      }
    }
  }
`;

export { NoGeodata };
